import React from "react";
import { IonIcon } from "@ionic/react";
import { close } from "ionicons/icons";
import { useTranslation } from "react-i18next";
import "./IllyCaffeModalContentStyle.css";

export default function IllyModalContent(props) {
    const { closerHandler } = props;

    const { t } = useTranslation();

    return (
        <div className="illy-modal-content modal-wrapper overflow-auto p-4 flex flex-col gap-4 text-black">
            <div className="sticky top-0">
                <div className="flex flex-row justify-end">
                    <button type="button" onClick={closerHandler} className="text-2xl flex items-center justify-center">
                        <IonIcon slot="icon-only" icon={close}></IonIcon>
                    </button>
                </div>
            </div>

            <img src="/assets/illy-caffe.png" alt="login call to action" />

            <p className="text-center font-bold" >{t("illymodalcontent.p_1")}</p>
            <p className="text-center" >{t("illymodalcontent.p_2")}</p>
            <a className="py-2 px-4 rounded-full text-center" style={{ backgroundColor: "#512c1f", color: "white" }} href="https://www.illy.com/it-it/caffe">{t("illymodalcontent.a_1")}</a>
        </div>
    );
}
